<template>
  <el-dialog width="66%"
             top="0px"
             title="审批流程"
             :visible.sync="dialogVisible">
    <el-form :model="form"
             ref="ruleForm"
             :rules="rules">
      <el-row>
        <el-col :span="24">
          <el-form-item label="审核结果"
                        :label-width="formLabelWidth">
            <el-radio v-model="form.verifyType"
                      label="1">同意</el-radio>
            <el-radio v-model="form.verifyType"
                      label="2">不同意</el-radio>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="执行情况"
                        prop="WorkTitle"
                        :label-width="formLabelWidth">
            <el-input v-model="form.WorkTitle"
                      placeholder="请输入执行情况"
                      autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注"
                        :label-width="formLabelWidth">
            <editor v-model="form.description"
                    :isClear="isClear"></editor>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <el-button type="primary"
                 :disabled="isDisabled"
                 @click="onSubmit">确 定</el-button>
      <el-button type="danger"
                 @click="dialogVisible = false">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getToken } from "@/util/auth";
import { regular } from "@/api/modules/basicData/location";
import { Auditer } from "@/api/modules/basicData/workFlow";
import Editor from "@/components/common/editor";
import {
  GetRecordInfoByMainId,
  AddOrUpdateRecordInfo
} from "@/api/modules/basicData/task";
export default {
  components: {
    Editor
  },
  data() {
    var checknum = (rule, value, callback) => {
      value = this.trim(value);
      if (!value) {
        callback(new Error("不能为空"));
        this.time("ruleForm", "WorkTitle");
      } else {
        callback();
      }
      // var judge = regular('chinese', this.form.WorkTitle);
      // if (judge != true) {
      //     callback(judge)
      //     this.time('ruleForm', 'WorkTitle')
      // } else {
      //     callback()
      // }
    };
    return {
      form: {
        verifyType: "1",
        Auditor: {},
        description: ""
      },
      isClear: true,
      isDisabled: false,
      type: 0,
      task: {},
      RecordList: {},
      dialogVisible: false,
      checked: true,
      formLabelWidth: "120px",
      TaskInstance: "",
      BelongUser: "",
      TaskName: "",
      rules: {
        WorkTitle: [
          {
            validator: checknum,
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    /**添加工作记录提交 */
    onSubmit() {
      if (!this.isDisabled) {
        this.isDisabled = true;
        this.$refs["ruleForm"].validate(valid => {
          if (valid) {
            const user = getToken();
            const date = new Date();
            let paras = {
              // 注意： 运维人员列表里 并没有人员的机构，所以在归属人的机构处理了一下
              ID: this.Guid(),
              INFO: this.form.WorkContent,
              CREATEUSERID: user.userId,
              CREATEUSERNAME: user.realName,
              CREATEDEPTID: user.departmentId,
              CREATEDEPTNAME: user.departmentName,
              ENABLE: true,
              CREATECOMPANYID: user.organizationId,
              CREATECOMPANYNAME: "",
              CREATETIME: date,
              NAME: this.form.WorkTitle,
              ISOPEN: this.form.IsOpen,
              MAINID: this.task.ID,
              MAININSTANCE: this.task.INSTANCE,
              MAINTYPE: 0,
              INSTANCE: this.task.INSTANCE,
              RECORDTYPE: this.form.RECORDTYPE,
              STATE: 0
            };
            AddOrUpdateRecordInfo(parasInfo,null).then(pmevent => {
              if (pmevent === 1) {
                if (this.type === 0) {
                  this.$parent.initalTask();
                }
                // this.initalTask();
                // this.$emit('initalTask')
                this.dialogVisible = false;
                this.$message({
                  type: "success",
                  message: "添加工作记录成功。"
                });
              } else {
                this.$message({
                  type: "error",
                  message: "添加工作记录失败！"
                });
              }
              this.isDisabled = false;
              this.onClear();
            });
          } else this.isDisabled = false;
        });
      }
    },
    onClear() {
      this.$refs["ruleForm"].resetFields();
      this.form = {
        WorkTitle: "",
        RECORDTYPE: "0",
        IsOpen: true,
        WorkContent: ""
      };
    },
    onAuditer(isNew, schemeCode, processId, taskId, formData) {
      let cookieUser = getToken();
      let createUser = {
        userId: cookieUser.userId,
        realName: cookieUser.realName,
        companyId: cookieUser.companyId,
        departmentId: cookieUser.departmentId
      };
      Auditer(
        isNew,
        shcemeCode,
        processId,
        taskId,
        formData,
        "",
        JSON.stringify(createUser)
      ).then(item => {});
    }
  }
};
</script>

<style scoped=true>
.grid-content .el-row {
  padding: 5px 20px 0 20px;
}
.el-col {
  border-radius: 4px;
  text-align: left;
}
.button .el-button {
  background: #ecf5ff;
  color: #0099ff;
}
.button {
  margin: 20px 0 0 20px;
  float: left;
}
.bg-purple-dark {
  background: white;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.Details {
  background-color: #f3f3f3;
  min-height: 500px;
}
.title {
  text-align: left;
  font-family: MicrosoftYaHei-Bold;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 0px;
  color: #0099ff;
}
.abstract {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #606266;
}
.tagtitle {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #858585;
}
</style>